module.exports = __webpack_public_path__ + "img/1.283be461.png";